module.exports = __webpack_public_path__ + "8607fcb6352dc398c615122619a945f6.jpg";